import React from 'react'
import logo from 'assets/svgs/applogo_light.svg';
import './LoadingPage.css';
import useTranslate from "../modules/local/useTranslate";


const LoadingPage = ({style = {}, className = "", logoSrc = logo}) => {
    const t = useTranslate()
    return (
        <div className="loading-container flex flex-col items-center justify-center">
            <div style={style} className={className}>
                <img
                    width={128}
                    height={128}
                    src={logoSrc}
                    fetchpriority="high"
                    alt="Loading..."
                    className="pulse-logo"/>
            </div>
            <div className="loading-text">
                <span>{t('Loading')}</span>
                <div className="dot-loading">.</div>
                <div className="dot-loading">.</div>
                <div className="dot-loading">.</div>
            </div>
        </div>
    )
}

export default React.memo(LoadingPage)
